export default __webpack_public_path__ + "static/media/Mark-4-HUD-Dock Icons.efb579fd.jpg";